import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPayments } from '../../actions/adminActions';
import { translateDepositStatus } from '../../utils/translate';

var panelStyle = { paddingLeft: '20px', paddingRight: '20px' }

class Payments extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        // calling the new action creator
        this.props.localGetPayments();
    }

    render() {
        const { payments } = this.props;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="panel-title">Payments</h2>
                        <div className="panel">
                            <table className="table">
                                <thead>
                                    <tr>
                                    <th>User</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                    <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {typeof payments === 'undefined' || payments === null ? '' : (payments.map((payment, index) => (
                                        <tr key={payment.id}>
                                            <td>{payment.givenName} {payment.surname}</td>
                                            <td>{translateDepositStatus(payment.status)}</td>
                                        <td>{payment.amount} <small>{payment.currencyCode || 'USD'}</small></td>
                                        <td> {dateFormat(payment.created)}</td>
                                         <td className="text-right">
                                            <Link className="table-button" to={'/payments/' + payment.id}>
                                                View
                                            </Link>
                                        </td>
                                    </tr>
                                )))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function dateFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}

function mapStateToProps(state) {
    return {
        payments: state.adminReducer.payments.payments,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //function
        localGetPayments: () => dispatch(getPayments()),
    };
}

const payments = connect(mapStateToProps, mapDispatchToProps)(Payments);
export { payments as Payments }; 